import EventEmitter from 'events';

const EventsEnum = {
  FETCH_USER_DATA: 'FETCH_USER_DATA',
};

export default new EventEmitter();

export { EventsEnum };
